import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import 'intl-tel-input';
import { FormValidationComponent } from '../form-validation/form-validation.component';
import { EmitterService } from '../services/emitter.service';
import { ProfileSettingService } from '../services/profile-setting.service';
import { UserDetailsService } from '../services/user-details.service';
import { CustomValidators } from '../shared/utility/custom-validator';
import { Utility } from '../shared/utility/utility';
import { AjaxService } from '../services/ajax.service';
import { TranslateService } from '@ngx-translate/core';
import { ZendeskService } from "../services/zendesk.servcie";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CountryDataService } from '../services/country.service';
import * as $ from 'jquery';
import { environment } from '../../environments/environment';
import { Utilities } from '../services/utilities.services';
window['$'] = window['jQuery'] = $;

@Component({
  selector: 'app-zimpler-complete-profile',
  templateUrl: './app-zimpler-complete-profile.component.html',
  styleUrls: ['./app-zimpler-complete-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppZimplerCompleteProfileComponent extends FormValidationComponent implements OnInit, AfterViewInit, OnDestroy {

  updateCredentialsForm = this.formBuilder.group({
    'email': ['', {updateOn: 'blur', validators:[this.CustomValidators.validateUniqueness("txtEmail", this.ajaxService, true)]}],
    'areaCode': ['', this.CustomValidators.required],
    'areaCountryCode': ['', this.CustomValidators.required],
    'phone': ['', [this.CustomValidators.phoneNumberValidator]],
    'password': ['', this.CustomValidators.validatePassword(8)],
  })
  userDetails: any;
  viewPassword: boolean = false;
  focusPassword = false;
  langCode: string;
  message: boolean = false;
  serverError: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  ipCountry: any;
  isZendeskEnabled = environment.zendeskServiceConfig["isEnabled"];
  isShowDisclaimer = false;
  isSubmitted = false;

  constructor(private formBuilder: FormBuilder,
    private CustomValidators: CustomValidators,
    private userDetailsService: UserDetailsService,
    private profileSettingService: ProfileSettingService,
    private utils: Utility,
    private emitterService: EmitterService,
    private translationService:TranslateService,
    private ajaxService:AjaxService,
    private zenDesk:ZendeskService,
    private countryDataService: CountryDataService,
    private utilities: Utilities  ) {
    super(utils)

    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

    this.emitterService.userCountry$.pipe(takeUntil(this.destroy$)).subscribe(country => {
      this.ipCountry = country
      this.checkDisclaimerText();
      this.setCountryCodeData()
    });
  }
  checkDisclaimerText(){
    if(this.userDetailsService.userProfileDetails && this.userDetailsService.userProfileDetails.jurisdiction == "estonia"){
      this.isShowDisclaimer = true;
     }else{
       this.isShowDisclaimer = false;
     }
  }
  ngOnInit() {
    this.ipCountry = this.userDetailsService.userProfileDetails.country;
    this.getUserDetails();
    this.checkDisclaimerText();
  }
  
  ngAfterViewInit(){
    this.setCountryCodeData()
  }

   toggleZDChat() {
    this.utilities.initChat();
  }

  setCountryCodeData() {
    if (!this.updateCredentialsForm.controls["areaCountryCode"].value) this.updateCredentialsForm.controls["areaCountryCode"].setValue(this.ipCountry);
    /*Settimeout used for HTML to be loaded and then "phoneNumberFlag" field can be captured*/
    setTimeout(() => {
      this.utils.setPhoneNumberDropdown("phoneNumberFlag", this.updateCredentialsForm.controls["areaCountryCode"].value, this.updateCredentialsForm);
      if (!this.updateCredentialsForm.controls["areaCode"].value) this.updateCredentialsForm.controls["areaCode"].setValue($("#phoneNumberFlag").intlTelInput("getSelectedCountryData").dialCode);
    }, 100);
  }

  getUserDetails() {
    Promise.resolve(this.profileSettingService.getProfileData(true)).then(profileData => {
      this.userDetails = this.userDetailsService.getUserProfileDetails();
    })
  }

  updateCredentials() {
    this.isSubmitted = true;
    if (this.updateCredentialsForm.valid && !this.CustomValidators.phoneNumbervalidationInProgress) {
      this.updateCredentialsForm = this.userDetailsService.cleanForm(this.updateCredentialsForm);
      let requestData = this.utils.formControlToParams(this.updateCredentialsForm, {});
      Promise.resolve(this.ajaxService.doCredentialsUpdate(requestData)).then(res => {
        if (res && res["status"] === "SUCCESS") {

          this.userDetailsService.setUserProfileDetails(requestData);

          this.emitterService.userDataSourceComplete("User Data Updated");
          this.emitterService.broadcastLoadHomeBanner("User_Data_Updated");
          Promise.resolve(this.profileSettingService.getProfileData(true)).then(profileData => {
            this.Close()
            this.userDetails = this.userDetailsService.getUserProfileDetails();
          });
        }
        else {
          this.serverError = this.translationService.instant('errors.error')
          setTimeout(() => {
            this.serverError = null;
          }, 5000);
          this.clearForm()
        }
      });
    } else {
      this.utils.validateAllFormFields(this.updateCredentialsForm);
    }
  }
  trimPassowrd(){
    let password = this.updateCredentialsForm['password'].value;
    this.updateCredentialsForm['password'].setValue(password.trim())
  }
  clearForm() {
    this.updateCredentialsForm.reset()
    this.setCountryCodeData()
  }

  checkmobilereg(check) {
    let updateData = this.utils.formControlToParams(this.updateCredentialsForm, {});
    let validateValues = {
      mobileNumber: updateData.phone,
      mobileIsdCode: updateData.areaCode
    }
    if (!updateData.phone || !updateData.areaCode) {
      let message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      this.updateCredentialsForm.controls['phone'].setErrors(message);
    }
    else {
      Promise.resolve(this.userDetailsService.checkmobilereg(validateValues)).then(data => {
        if (data !== "already exists") {
          if (check) {
            if (this.updateCredentialsForm.valid) {
              this.updateCredentialsForm.controls['phone'].setErrors(null);
              this.updateCredentials();
            } else {
              this.utils.validateAllFormFields(this.updateCredentialsForm);
            }
            this.utils.deleteNotifyCookie('otp' + this.userDetails.nickname);
          }
        } else {
          this.updateCredentialsForm.controls['phone'].setErrors({ 'message': 'Phone number already Registered' });
        }
        this.emitterService.broadCastnotificationEvent("");
      });
    }
  }

  getButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName)
  }
  shouldShowPwdError(fieldName, formName) {
    return this.utils.shouldShowErrors(fieldName, formName)
  }

  Close() {
    this.clearForm()
    this.emitterService.broadCastIsZimplerForm(false)
  }

  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
